import { render, staticRenderFns } from "./Choropleth.vue?vue&type=template&id=5369b74f&"
import script from "./Choropleth.vue?vue&type=script&lang=js&"
export * from "./Choropleth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports